import React from 'react';
import './videos.css';
import channels from './videos.json';

const Videos = () => (
    <section id="videos" aria-labelledby="videos-title">
        <h2 id="videos-title">Watch our videos</h2>
        <p className="videosDescription">Explore conversations from Godfrey Kuteesa and stories from the Boys' Mentorship Programme.</p>
        {channels.map((channel) => (
        <section className="videoGroup" key={channel.id} aria-labelledby={channel.id}>
        <h3 id={channel.id} className="videoGroupTitle">{channel.title}</h3>
        <div className="videosGrid">
            {channel.videos.map((video) => (
                <article className="videoCard" key={video.id}>
                    <div className="videoPlayer">
            <iframe
                src={`https://www.youtube.com/embed/${video.id}?playsinline=1`}
                title={video.title}
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            />
                    </div>
                    <h4>{video.title}</h4>
                    <a href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noopener noreferrer">Watch on YouTube</a>
                </article>
            ))}
        </div>
        <a className="videosChannel" href={channel.url} target="_blank" rel="noopener noreferrer">More from {channel.title}</a>
        </section>
        ))}
        <p className="videosHint">If a video cannot play here, watch it on YouTube.</p>
    </section>
);

export default Videos;
